import { HttpClient } from '@angular/common/http';
import { Injectable, TransferState } from '@angular/core';
import { HttpLink } from 'apollo-angular/http';

import { Apollo } from 'apollo-angular';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class lectureContentService extends BaseGQLService<any> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: lectureContentModel,
        clientName: 'lectureContentService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryLecturersContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState
    );
  }



}

export class lectureContentModel{
  id:string = '';
  flatData:lectureContentDetails = new lectureContentDetails();
}

export class lectureContentDetails{
  lecturername:string = '';

}